import style from "./style.scss";
import { Fragment } from "preact";
import { useId } from "preact/hooks";
import { usePopup } from "../popup/context";
import ButtonList from "./button-list";
import Button from "./button";
import Popup from "../popup";
import Editorial from "../editorial";

const OptionsButton = ({
  options,
  icon = null,
  secondary = false,
  children,
  ...props
}) => {
  const popup = usePopup();
  const modalTitleId = useId();

  const openPopup = (e) => {
    e.preventDefault();
    popup.showPopup(
      <Popup ariaLabelledBy={modalTitleId}>
        <div class={style.popupWrapper}>
          <Editorial>
            <h4 id={modalTitleId}>Which Model?</h4>

            {options.map((option, i) => (
              <Fragment key={i}>
                <ButtonList>
                  <Button
                    href={option.href}
                    affiliate={option.affiliate}
                    affiliateData={option.affiliateData}
                    external={option.external}
                    blank={option.blank}
                    target={option.target}
                    rel={option.rel}
                    class={option.class}
                    icon={icon}
                    secondary={secondary}
                  >
                    {option.text}
                  </Button>
                </ButtonList>
              </Fragment>
            ))}
          </Editorial>
        </div>
      </Popup>
    );
  };

  return (
    <Button
      icon={icon}
      secondary={secondary}
      onClick={(e) => openPopup(e)}
      {...props}
    >
      {children}
    </Button>
  );
};

export default OptionsButton;
